import {
  faAngleDown,
  faBars,
  faBan,
  faBoxes,
  faBriefcase,
  faCity,
  faCheck,
  faCheckCircle,
  faChevronDown,
  faClock,
  faCoins,
  faCircle,
  faGift,
  faGlobeAmericas,
  faHome,
  faListUl,
  faMapMarkedAlt,
  faMapMarkerAlt,
  faMobileAlt,
  faPhone,
  faPlusCircle,
  faShoppingCart,
  faSignOutAlt,
  faSyncAlt,
  faTimesCircle,
  faUndo,
  faUsers,
  faTimes,
  faTransgender,
  faTruck,
  faUser as faUserSolid,
  faSign,
  faStreetView,
  faUserTie,
  faBarcode,
  faCreditCard,
  faEnvelope,
  faEnvelopeOpen,
  faEnvelopeOpenText,
  faEnvelopeSquare,
  faExclamationTriangle,
  faHeadset,
  faInfoCircle,
  faPlus,
  faUserLock,
  faLock,
  faBox,
  faDollarSign,
} from "@fortawesome/free-solid-svg-icons";

export default {
  faAngleDown,
  faBars,
  faBan,
  faBoxes,
  faBriefcase,
  faCity,
  faGlobeAmericas,
  faCheck,
  faCheckCircle,
  faChevronDown,
  faClock,
  faCoins,
  faCircle,
  faGift,
  faHome,
  faListUl,
  faMapMarkedAlt,
  faMapMarkerAlt,
  faMobileAlt,
  faPhone,
  faPlusCircle,
  faShoppingCart,
  faSignOutAlt,
  faSyncAlt,
  faTimesCircle,
  faUndo,
  faUsers,
  faTimes,
  faTransgender,
  faTruck,
  faUserSolid,
  faSign,
  faStreetView,
  faUserTie,
  faBarcode,
  faCreditCard,
  faEnvelope,
  faEnvelopeOpen,
  faEnvelopeOpenText,
  faEnvelopeSquare,
  faExclamationTriangle,
  faHeadset,
  faInfoCircle,
  faPlus,
  faUserLock,
  faLock,
  faBox,
  faDollarSign,
};
